import {LayerEsriMapServer, makeServiceUrl} from "webmapsjs/dist/layers/LayerEsriMapServer";
import TileArcGISRest from 'ol/source/TileArcGISRest';
import $ = require("jquery");



export const metrics = ['Volume', 'Speed'];
export const times = ['AM Peak', 'PM Peak', 'Day', 'Saturday'];

export const numWeeks = 12;


export const covidLyr = new LayerEsriMapServer(makeServiceUrl("NPMRDS", 'covid'), {visible: true});
covidLyr.olLayer.setSource(
    new TileArcGISRest({
        url: makeServiceUrl("NPMRDS", 'covid'),
        transition: 0
    })
);


export let legend = {};

$.get(makeServiceUrl("NPMRDS", 'covid') + '/legend?f=json',
    (d) => {
    legend = d;
    }, 'json');




